import { getCookie } from 'src/utils/browser';
import { useState, useEffect, useCallback } from 'react';

export function useSession({ sessionServices }) {

	const {
		getCookieList,
		getServerDomain,
		validateToken,
		getUserInfoByToken,
		getInformationUser
	} = sessionServices;

	const [sessionState, setSessionState] = useState({ logeado: null, invitado: null, user: null});

	const clearSessionCookies = useCallback(() => async () => {
		const awaitCookieList = await getCookieList();
		const serverDomain = await getServerDomain();
		awaitCookieList.forEach(cookieName => {
			document.cookie = `${cookieName}=; Path=/; domain=${serverDomain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=lax;`;
			document.cookie = `${cookieName}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
		});
		return undefined;
	}, []);

	useEffect(() => {
		if(!document && document.cookie === undefined) return undefined;

		const cookie = document.cookie;
		const cookieToctoc = getCookie(cookie);

		let getUser = async (cookiett) => {
			const { name: cookieName, value: cookieValue } = cookiett ?? {};
			
			let user = await getUserInfoByToken(cookieValue)
				.catch(error => {
				// console.error(error);
				})

			if(!user || user.email === undefined || user.email === '') return undefined;
			const { name, email, role } = user ?? {};
			setSessionState({
				logeado: user !== null && email !== undefined && cookieName === 'token',
				invitado: user !== null && email !== undefined && cookieName === 'tt-jwt-gauth',
				user: { name: name, email: email, role: role },
			});
			
			return undefined
		}

		getUser(cookieToctoc)

		
	}, [])

	useEffect(() => {

		if (sessionState.logeado === false) clearSessionCookies()();

		return undefined;

	}, [sessionState.logeado, clearSessionCookies]);

	const setupCallback = useCallback(() => {
		const cookie = document.cookie;
		const cookieToctoc = getCookie(cookie);
		const { name: cookieName, value: cookieValue } = cookieToctoc ?? {};

		if (validateToken !== null && validateToken !== undefined && cookieValue !== null && cookieValue !== undefined && cookieName === 'token') {
			
			validateToken(cookieValue)
				.then((isValidToken) => {

					if (isValidToken.status) {
						let user = getUserInfoByToken(cookieToctoc);
						return user;
					}

				})
				.then((user) => {
					setSessionState({
						logeado: true,
						invitado: false,
						user: { name: user.name, email: user.email }
					});
					let informationUser = getInformationUser(user.email);
					return informationUser;
				})
				.catch(error => {
					console.error(error);
				})
				.then((informationUser) => {
					const { data } = informationUser ?? {};
					const { nombres, perfilesUsuario, fechaCreacion, email } = data ?? {};
					const createDateValue = fechaCreacion ? new Date(fechaCreacion).getTime() : Date.now();
					if (nombres !== undefined) {
						const userFromRequest = {
							name: nombres,
							role: perfilesUsuario !== undefined && perfilesUsuario.length > 0 ? perfilesUsuario.map(p => p.idPerfil) : 0,
							email,
							createDate: Math.floor(createDateValue / 1000)
						};
						setSessionState({
							logeado: true,
							invitado: false,
							user: userFromRequest
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		}
	}, []);

	return [sessionState, setSessionState, setupCallback];
}